<template>
  <div class="box company-detail">
    <div class="box-header">
      <h3 class="box-title">Social Media</h3>
    </div>
    <div class="item">
      <input type="text" v-model="form.facebook" class="input" placeholder="Facebook" />
    </div>
    <div class="item">
      <input type="text" v-model="form.youtube" class="input" placeholder="Youtube" />
    </div>
    <div class="item">
      <input type="text" v-model="form.titok" class="input" placeholder="Tiktok" />
    </div>
    <div class="item">
      <input type="text" v-model="form.twitter" class="input" placeholder="Twitter" />
    </div>
    <div class="item">
      <input type="text" v-model="form.linkIn" class="input" placeholder="Linkin" />
    </div>
  </div>
</template>

<script>
export default {
  props: ['isSocial'],
  data: () => ({
    form: {
      facebook: "",
      youtube: "",
      titok: "",
      twitter: "",
      linkIn: ""
    }

  }),
  watch: {
    form: {
      handler(val) {
        this.$emit("input", val)
      },
      immediate: true,
      deep: true
    },
    isSocial() {
      this.form = {
        facebook: this.isSocial.facebook,
        youtube: this.isSocial.youtube,
        titok: this.isSocial.titok,
        twitter: this.isSocial.twitter,
        linkIn: this.isSocial.linkIn
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  i {
    cursor: pointer;
    top: 0;
    right: 0;
    width: 30px;
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(var(--alert-color-rgb), 0.1);
    color: var(--alert-color);
  }

  input {
    border-radius: 0 !important;
  }

  &:not(:last-child) {
    margin-bottom: 10px;
  }
}
</style>
